<div id="main" class="h-[100dvh] flex flex-col relative bg-white dark:bg-dark-base"
     *ngIf="getUserInfo() | async as userInfo" (click)="trackFirstUserInteraction()">

  <!-- FIN-0106: Header with Circle-First Design - pill buttons, 120Hz animations -->
  <!-- FIN-0108: Dark mode uses warm dark base, subtle border -->
  <!-- FIN-0110: Cross-app navigation with home link -->
  <div id="top_buttons" class="flex-none flex justify-between items-center select-none z-50 bg-white/95 dark:bg-dark-base/95 backdrop-blur-sm border-b border-gray-100 dark:border-dark-border px-2 py-1.5">
    <div class="flex items-center gap-1.5">
      <!-- Home Button - circle (leftmost for global navigation) -->
      <a href="https://dev.finderwise.com"
         class="flex items-center justify-center w-10 h-10 rounded-full hover:bg-gray-100 dark:hover:bg-dark-surface active:scale-95 transition-all duration-fast ease-snap will-change-transform"
         style="-webkit-tap-highlight-color: transparent; touch-action: manipulation;"
         title="FinderWise Home">
        <span class="text-lg">🧪</span>
      </a>

      <!-- History Button - pill shape -->
      <button type="button"
              class="flex items-center gap-2 px-3 py-2 rounded-full hover:bg-gray-100 dark:hover:bg-dark-surface active:scale-95 transition-all duration-fast ease-snap will-change-transform"
              style="-webkit-tap-highlight-color: transparent; touch-action: manipulation;"
              (click)="toggleHistorySidebar()">
        <svg class="w-5 h-5 text-gray-600 dark:text-dark-text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
        </svg>
        <span class="text-sm text-gray-600 dark:text-dark-text-secondary hidden lg:block">History</span>
      </button>

      <!-- New Chat Button - pill shape -->
      <button type="button"
              class="flex items-center gap-2 px-3 py-2 rounded-full bg-gray-100 dark:bg-dark-elevated hover:bg-gray-200 dark:hover:bg-dark-surface active:scale-95 transition-all duration-fast ease-snap will-change-transform"
              style="-webkit-tap-highlight-color: transparent; touch-action: manipulation;"
              (click)="createNewConversation()">
        <svg class="w-5 h-5 text-gray-600 dark:text-dark-text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
        </svg>
        <span class="text-sm font-medium text-gray-700 dark:text-dark-text-primary hidden lg:block">New Chat</span>
      </button>

      <!-- Copy DOM Button - circle (icon only) -->
      <button type="button"
              class="flex items-center justify-center w-10 h-10 rounded-full hover:bg-gray-100 dark:hover:bg-dark-surface active:scale-95 transition-all duration-fast ease-snap will-change-transform"
              style="-webkit-tap-highlight-color: transparent; touch-action: manipulation;"
              (click)="copyDOMToClipboard()">
        <svg class="w-5 h-5 text-gray-500 dark:text-dark-text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/>
        </svg>
      </button>
    </div>
    <app-login></app-login>
  </div>

  <!-- Scrollable content area with bottom padding for fixed prompt -->
  <div class="flex-1 min-h-0 overflow-hidden relative">
    <!-- Gmail-style progress bar - shows during IndexedDB restoration -->
    <!-- FIN-0108: Dark mode uses desaturated brand color -->
    <div *ngIf="isRestoringFromIndexedDB"
         class="absolute top-0 left-0 right-0 h-1 bg-gray-200 dark:bg-dark-border z-50 overflow-hidden">
      <div class="h-full bg-brand dark:bg-dark-brand animate-progress-bar"></div>
    </div>

    <!-- Connection Status Banner (All States) -->
    <!-- FIN-0108: Dark mode banners use elevated surface -->
    <div *ngIf="shouldShowConnectionStatus()"
         class="absolute top-0 left-0 right-0 px-4 py-2 z-20 flex items-center justify-center"
         [ngClass]="{
           'bg-gray-50 dark:bg-dark-elevated border-b border-gray-200 dark:border-dark-border': connectionState === 'CONNECTING',
           'bg-yellow-50 dark:bg-yellow-900/30 border-b border-yellow-200 dark:border-yellow-800': connectionState === 'RECONNECTING',
           'bg-red-50 dark:bg-red-900/30 border-b border-red-200 dark:border-red-800': connectionState === 'FAILED'
         }">
      <div class="flex items-center gap-3">
        <div [ngClass]="getConnectionStatusClass()">
          {{ getConnectionStatusMessage() }}
        </div>
        <button *ngIf="connectionState === 'FAILED' && !isRetrying"
                (click)="manualReconnect()"
                class="bg-brand dark:bg-dark-brand hover:bg-brand-600 dark:hover:bg-dark-brand-dim text-white px-4 py-1.5 rounded-full text-xs font-medium transition-all duration-fast active:scale-95">
          Try again
        </button>
        <span *ngIf="isRetrying" class="text-xs text-gray-600 dark:text-dark-text-tertiary">
          Retrying...
        </span>
      </div>
    </div>

    <!-- Orphaned Conversation Banner - FIN-0103: Brand colors, FIN-0108: Dark mode -->
    <div *ngIf="isOrphaned"
         class="absolute left-0 right-0 px-3 py-3 z-20 bg-brand-50 dark:bg-dark-brand-muted/30 border-l-4 border-brand-400 dark:border-dark-brand"
         [class.top-0]="!shouldShowConnectionStatus()"
         [class.top-12]="shouldShowConnectionStatus()">
      <div class="flex flex-col gap-2">
        <div class="flex items-start gap-2">
          <svg class="w-5 h-5 text-brand-600 dark:text-dark-brand flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
          </svg>
          <div class="flex-1 min-w-0">
            <p class="text-sm text-brand-800 dark:text-dark-text-primary font-medium">
              Working offline - messages saved locally
            </p>
            <p class="text-xs text-brand-700 dark:text-dark-text-secondary mt-1">
              You can continue sending messages. They'll sync when you reconnect. ({{ orphanReason }})
            </p>
          </div>
        </div>
        <div class="flex flex-wrap gap-2 pl-7">
          <button
            (click)="uploadOrphanedConversation()"
            class="flex-1 min-w-[120px] bg-brand dark:bg-dark-brand hover:bg-brand-600 dark:hover:bg-dark-brand-dim text-white px-4 py-1.5 rounded-full text-xs font-medium transition-all duration-fast active:scale-95">
            Sync Now
          </button>
          <button
            (click)="deleteOrphanedConversation()"
            class="flex-1 min-w-[120px] bg-white dark:bg-dark-elevated hover:bg-gray-50 dark:hover:bg-dark-surface text-brand-700 dark:text-dark-brand border border-brand-200 dark:border-dark-brand-muted px-4 py-1.5 rounded-full text-xs font-medium transition-all duration-fast active:scale-95">
            Delete Conversation
          </button>
        </div>
      </div>
    </div>

    <div id="conversation" #conversationContainer
         class="h-full flex flex-col overflow-y-auto scrollbar-none px-2 scroll-smooth pb-0"
         [class.pt-12]="shouldShowConnectionStatus() && !isOrphaned"
         [class.pt-36]="isOrphaned && !shouldShowConnectionStatus()"
         [class.pt-48]="isOrphaned && shouldShowConnectionStatus()">

      <!-- Loading skeleton - prevents flicker during IndexedDB restoration -->
      <!-- The progress bar at the top provides visual feedback, so we keep this minimal -->
      <div *ngIf="isRestoringFromIndexedDB" class="flex-1 flex items-center justify-center">
        <div class="text-gray-300 dark:text-dark-text-muted text-xs font-light">Restoring conversation...</div>
      </div>

      <!-- Messages - only render after IndexedDB restoration completes -->
      <ng-container *ngIf="!isRestoringFromIndexedDB">
        <!-- Spacer that grows to push messages down when there's extra space -->
        <div class="flex-grow"></div>

        <ng-container *ngFor="let chatMessage of chatMessages; let i = index; trackBy: trackByMessageId">
          <app-message
            [chatMessage]="chatMessage"
            [isLastBotMessage]="isLastBotMessage(chatMessage, i)"
            [isFirstBotMessage]="isFirstBotMessage(chatMessage, i)"
            [demoPortal]="false">
          </app-message>
        </ng-container>
        <!-- Bottom anchor for auto-scroll -->
        <div id="bottom-anchor" class="h-0"></div>
      </ng-container>
    </div>

    <!-- FIN-0106: New message indicator - pill shape, 120Hz animations -->
    <!-- FIN-0108: Dark mode uses desaturated brand color -->
    <div *ngIf="isUserScrolledUp && hasNewMessages"
         class="fixed bottom-24 left-1/2 transform -translate-x-1/2 z-40 animate-message-in">
      <button (click)="scrollToBottom(true)"
              class="bg-brand dark:bg-dark-brand hover:bg-brand-600 dark:hover:bg-dark-brand-dim text-white px-5 py-2.5 rounded-full shadow-lg dark:shadow-black/30 flex items-center gap-2 transition-all duration-fast active:scale-95 will-change-transform">
        <span class="text-sm font-medium">New message</span>
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"/>
        </svg>
      </button>
    </div>
  </div>

  <!-- Prompt at bottom -->
  <app-prompt [canSend]="canSendMessages()"></app-prompt>

  <!-- Chat History Sidebar (FIN-0102) -->
  <app-chat-history-sidebar
    [(isOpen)]="isSidebarOpen"
    (conversationSelected)="onConversationSelected($event)"
    (newConversationRequested)="onNewConversationFromSidebar()">
  </app-chat-history-sidebar>
</div>
